var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.438 24V12.97h3.833l.574-3.958h-4.407v-2.95c0-1.235.358-2.077 2.205-2.077L18 3.984V.168C17.592.116 16.194 0 14.566 0 11.17 0 9.067 1.988 9.067 5.64v3.372H5.046v3.959h4.021V24h4.371z","fill":"currentColor","fillRule":"evenodd"}));
}

FacebookInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
